// Dependency
import React from 'react';

// Styles
import * as productStyles from '../../../templates/product/product.module.scss';
import * as ProductCardStyles from "../../cards/product-card.module.scss";

// Internationalization
import { useTranslation } from 'react-i18next';

// Template
const ProductPrice = ({ price, priceBeforeDiscount, newPrice, noVatPrice, isVariable, variant, discountPercent }) => {

    // Translation Function
    const { t } = useTranslation();

    const comparePrice = isVariable ? variant.price : price

    const roundedDiscount = Math.round(discountPercent)

    return (
        <div>
            <div className={`${productStyles.cdProductPrice} cd-product-price`}>
                { noVatPrice ?
                    <>
                        <div className={`cd-product-price`}>
                            <label>{t('productInfo.exVat')}</label>
                            <span className="cd-product-price-value cd-no-vat-price">{noVatPrice}</span>
                        </div>
                    </>
                    :
                    <>
                        { newPrice ?
                            <div className={productStyles.cdNewPrice}>
                                <div className={productStyles.cdTag}>{t('productInfo.newPrice')}</div>
                                <div className={`cd-original-price`}>
                                    <span className="cd-product-price-value">{newPrice}</span>
                                </div>
                            </div>
                            : ''
                        }
                        { priceBeforeDiscount && priceBeforeDiscount !== comparePrice  ?
                            <div className={`cd-original-price`}>
                                <span className="cd-product-price-value">{priceBeforeDiscount}</span>
                            </div>
                            : ''
                        }
                        <span className={`${priceBeforeDiscount && priceBeforeDiscount !== comparePrice || newPrice ? 'cd-price-red' : ''} cd-product-price-value`}>
                            {isVariable ? variant.price : price}
                        </span>
                    </>
                }
                { roundedDiscount > 0 ?
                    <span className={productStyles.cdProductPriceDiscount}> -{roundedDiscount}%</span>
                    : ''
                }
            </div>
        </div>

    )
};

export default ProductPrice;